import './index.css';

const Loader = (props) => props.loading ? <><div className="lds-facebook"><div></div><div></div><div></div></div></> : props.children

export default Loader;
